function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTvColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ABB8B9"
    },
    d: "M490.666,58.668H21.333c-5.865,0-10.665,4.8-10.665,10.666v319.999c0,5.868,4.8,10.666,10.665,10.666 h88.755h291.826h88.751c5.868,0,10.666-4.798,10.666-10.666V69.334C501.333,63.468,496.534,58.668,490.666,58.668z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000003"
    },
    d: "M490.666,48H21.333C9.57,48,0,57.571,0,69.334v319.999c0,11.763,9.57,21.334,21.333,21.334h72.042 l-17.719,38.175c-1.533,3.304-1.275,7.161,0.686,10.23c1.959,3.07,5.35,4.928,8.992,4.928h341.334c0.007,0,0.015,0,0.021,0 c5.892,0,10.667-4.776,10.667-10.667c0-1.844-0.468-3.581-1.292-5.095l-17.438-37.571h72.041c11.763,0,21.334-9.571,21.334-21.334 V69.334C512,57.571,502.429,48,490.666,48z M409.955,442.666H102.044l14.852-31.998h278.208L409.955,442.666z M401.916,389.332 c-0.001,0-0.002,0-0.002,0H110.087c-0.004,0-0.009,0.001-0.013,0.001h-88.74L21.333,69.335l469.332-0.001l0.004,319.998H401.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000003"
    },
    d: "M53.333,292.453c-5.892,0-10.667,4.776-10.667,10.668v54.214c0,5.892,4.776,10.667,10.667,10.667 s10.667-4.776,10.667-10.667v-54.214C64.001,297.229,59.226,292.453,53.333,292.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000003"
    },
    d: "M53.329,283.144c5.892,0,10.667-4.776,10.667-10.668v-0.254c0-5.892-4.776-10.668-10.667-10.668 c-5.891,0-10.667,4.776-10.667,10.668v0.254C42.661,278.368,47.438,283.144,53.329,283.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000003"
    },
    d: "M458.663,175.524c-5.891,0-10.668,4.776-10.668,10.667v0.256c0,5.892,4.777,10.667,10.668,10.667 c5.892,0,10.667-4.776,10.667-10.667v-0.256C469.33,180.3,464.554,175.524,458.663,175.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000003"
    },
    d: "M458.667,90.668c-5.892,0-10.667,4.776-10.667,10.667v54.212c0,5.892,4.776,10.667,10.667,10.667 s10.668-4.776,10.668-10.667v-54.212C469.334,95.444,464.558,90.668,458.667,90.668z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvColor);
export default __webpack_public_path__ + "static/media/tv_color.db038a42c6cf065886cdddd6705b24c4.svg";
export { ForwardRef as ReactComponent };